import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, message } from "antd";
import { useNavigate } from "react-router-dom";
import {
  RootServicePartnerCreateDto,
  createRootServicePartner,
} from "@/lib/api/resources/rootServicePartners";
import {
  RootServicepartnerForm,
  RootServicepartnerFormValues,
  buildAddressPayload,
} from "./components/RootServicepartnerForm";

export const RootServicepartnerCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [form] = Form.useForm<RootServicepartnerFormValues>();

  const mutation = useMutation({
    mutationFn: (values: RootServicepartnerFormValues) => {
      const payload: RootServicePartnerCreateDto = {
        name: values.name!,
        groupName: values.groupName,
        email: values.email,
        telephone: values.telephone,
        website: values.website,
        dwproAudaboxNumber: values.dwproAudaboxNumber,
        externalReference: values.externalReference,
        address: buildAddressPayload(values.address),
        postalAddress: buildAddressPayload(values.postalAddress),
      };

      return createRootServicePartner(payload);
    },
    onSuccess: () => {
      message.success("ServicePartner aangemaakt");
      queryClient.invalidateQueries({ queryKey: ["root-service-partners"] });
      navigate("/base/service-partners");
    },
    onError: () => {
      message.error("Aanmaken mislukt");
    },
  });

  return (
    <RootServicepartnerForm
      form={form}
      title="ServicePartner aanmaken"
      submitting={mutation.isPending}
      submitLabel="Aanmaken"
      onSubmit={(values) => mutation.mutate(values)}
      onCancel={() => navigate("/base/service-partners")}
    />
  );
};
